module.exports = __webpack_public_path__ + "img/bookly.4ea00bf2.png";